var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "setting",
    d: "M63.833,57.9a5.628,5.628,0,0,0,.046-.9c0-.315-.046-.585-.046-.9l1.933-1.485a.413.413,0,0,0,.092-.585l-1.841-3.105a.448.448,0,0,0-.552-.18l-2.3.9a6.7,6.7,0,0,0-1.565-.9l-.322-2.385a.493.493,0,0,0-.46-.36H55.134a.493.493,0,0,0-.46.36l-.368,2.385a7.794,7.794,0,0,0-1.565.9l-2.3-.9a.431.431,0,0,0-.552.18l-1.841,3.105a.544.544,0,0,0,.092.585L50.117,56.1c0,.315-.046.585-.046.9s.046.585.046.9l-1.933,1.485a.413.413,0,0,0-.092.585l1.841,3.105a.448.448,0,0,0,.552.18l2.3-.9a6.7,6.7,0,0,0,1.565.9l.368,2.385a.446.446,0,0,0,.46.36h3.682a.493.493,0,0,0,.46-.36l.369-2.385a7.79,7.79,0,0,0,1.565-.9l2.3.9a.431.431,0,0,0,.552-.18l1.841-3.105a.543.543,0,0,0-.092-.585L63.833,57.9Zm-6.858,2.25A3.151,3.151,0,1,1,60.2,57,3.167,3.167,0,0,1,56.975,60.151Z",
    transform: "translate(-47.998 -48.001)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBlack);
export default __webpack_public_path__ + "static/media/settingBlack.ba10d65568887ea3d8753cfc01c46ddd.svg";
export { ForwardRef as ReactComponent };